export enum RationaleTemplateActionDispatchTypes {
  GET_RATIONALE_TEMPLATE_FORM_INVOKE = "GET_RATIONALE_TEMPLATE_FORM_INVOKE",
  GET_RATIONALE_TEMPLATE_FORM_SUCCESS = "GET_RATIONALE_TEMPLATE_FORM_SUCCESS",
  GET_RATIONALE_TEMPLATE_FORM_RESET = "GET_RATIONALE_TEMPLATE_FORM_RESET",

  PUT_RATIONALE_TEMPLATE_FORM_INVOKE = "PUT_RATIONALE_TEMPLATE_FORM_INVOKE",
  PUT_RATIONALE_TEMPLATE_FORM_SUCCESS = "PUT_RATIONALE_TEMPLATE_FORM_SUCCESS",
  PUT_RATIONALE_TEMPLATE_FORM_RESET = "PUT_RATIONALE_TEMPLATE_FORM_RESET",
  PUT_RATIONALE_TEMPLATE_FORM_ERROR = "PUT_RATIONALE_TEMPLATE_FORM_ERROR",

  POST_RATIONALE_TEMPLATE_FORM_INVOKE = "POST_RATIONALE_TEMPLATE_FORM_INVOKE",
  POST_RATIONALE_TEMPLATE_FORM_SUCCESS = "POST_RATIONALE_TEMPLATE_FORM_SUCCESS",
  POST_RATIONALE_TEMPLATE_FORM_RESET = "POST_RATIONALE_TEMPLATE_FORM_RESET",
  POST_RATIONALE_TEMPLATE_FORM_ERROR = "POST_RATIONALE_TEMPLATE_FORM_ERROR",
}

export const RationalTemplateFormDetails = {
  title1: "When denied your home health services because:",
  description1:
    "Please provide a detailed rationale, as this explanation will be included in the denial letter sent to the patient.",
  title2:
    "The following are the resources were utilized in the decision to deny services:",
  description2:
    "Please describe the resources referenced when making your decision, as this information will be included in the denial letter sent to the patient.",
};

export const RationaleTemplateFormNames = {
  rationaleTemplateId: "rationaleTemplateId",
  templateName : "templateName",
  isActive: "isActive",
  rationaleDecision: "rationaleDecision",
  serviceRequestType : "serviceRequestType",
  discipline: "discipline",
  rationale: "rationale",
  resourceDescription: "resourceDescription"
} as const

export const rationaleTemplateInitials = {
  rationaleTemplateId: "",
  serviceRequestType: "",
  rationaleDecision: "",
  discipline: "",
  rationale: "",
  templateName: "",
  resourceDescription: "",
  isActive: true,
}